<app-filters-group [title]="title" [form]="form" [filtersGroup]="[name]" [formGroup]="form">
    <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <mat-select [formControlName]="name">
            <mat-option *ngFor="let option of optionsValue" [value]="option" style="font-size: 80%;">
                {{ option }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</app-filters-group>